import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppRoutes } from './router';
import InstallPrompt from './components/feature/InstallPrompt';
import AdModal from './components/feature/AdModal';
import ScrollToTop from './components/feature/ScrollToTop';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        <InstallPrompt />
        <AdModal />
        <ScrollToTop />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
